import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { CaretLeft } from "@phosphor-icons/react";

/**
 * A client page's one heading, the second build round of 2026-09-24 (`prototype/kund/pages.js`,
 * `head()`): the title, the page's one act beside it, and on a page one level down a way back above
 * it. Nothing under it, because design.md section 3's third rule took the paragraph away. A rule that
 * matters rides on the title as a `Hint`, passed in `after`.
 *
 * The admin's `PageHead` is the same idea in Petrovic's denser frame and is scoped under
 * `.admin-page`; this one is the client's, and the two share no class names.
 */
export function ClientHead({
  title,
  titleId,
  back,
  actions,
  after
}: {
  title: ReactNode;
  titleId?: string;
  /** The page one level up, for a page reached from a list: Ärenden › one request. */
  back?: { to: string; label: string };
  actions?: ReactNode;
  after?: ReactNode;
}) {
  return (
    <header className="k-head">
      {back ? (
        <Link className="k-back" to={back.to}>
          <CaretLeft size={16} aria-hidden="true" />
          <span>{back.label}</span>
        </Link>
      ) : null}
      <div className="k-head-row">
        {/*
          The Hint sits beside the heading rather than inside it, so the heading's accessible name is
          the title alone and not "Konton och behörigheter Vad betyder det här?" (raised by the builder
          of Konton in the second build round).
        */}
        <div className="k-head-title">
          <h1 id={titleId}>{title}</h1>
          {after}
        </div>
        {actions ? <div className="k-head-actions">{actions}</div> : null}
      </div>
    </header>
  );
}
